import {Component, OnDestroy, OnInit, inject, output, input, effect} from '@angular/core';
import {Subscription} from "rxjs";
import {ProjectStatus, Right, ViewMode} from "../../../interfaces";
import {UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DataService} from "../../../../services/data.service";
import {FormService} from "../../../../services/form.service";
import {AccessService} from "../../../../services/access.service";
import {ToastrService} from "ngx-toastr";
import {ProjectService} from "../../../../services/project.service";
import {NgIf, DatePipe} from '@angular/common';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {DisableControlDirective} from '../../../../directives/disable-control.directive';
import {YesNoPipe} from '../../../../pipes/yes-no.pipe';
import {ProjectTypePipe} from '../../../../pipes/project-type.pipe';

@Component({
    selector: 'app-project-external',
    templateUrl: './project-external.component.html',
    styleUrl: './project-external.component.scss',
    imports: [NgIf, TooltipModule, FormsModule, ReactiveFormsModule, DisableControlDirective, DatePipe, YesNoPipe, ProjectTypePipe]
})
export class ProjectExternalComponent implements OnInit, OnDestroy {

    accessService = inject(AccessService);
    formService = inject(FormService);
    projectService = inject(ProjectService);
    private dataService = inject(DataService);
    private fb = inject(UntypedFormBuilder);
    private toastrService = inject(ToastrService);

    readonly PID = input.required<any>();
    readonly reloadTrigger = input<number>(0);

    readonly changeProject = output();
    readonly changeViewMode = output<boolean>();

    readonly ViewMode = ViewMode;
    readonly Right = Right;
    readonly ProjectStatus = ProjectStatus;

    viewMode!: ViewMode;
    project: any;
    form!: UntypedFormGroup;
    users: any[] = [];

    private teamsSubscription$: Subscription;

    private reloadEffect = effect(() => {
        if (this.reloadTrigger() > 0) {
            this.getProject();
        }
    })

    ngOnInit(): void {
        this.viewMode = ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            teams_created: [null],
            teams_created_at: [null],
            teams_creator: [null],
            teams_comment: [null],

            cost_centre: [null],
            cost_type: [''],

            dynamics_created: [null],
            dynamics_created_at: [null],
            dynamics_creator: [null],
            dynamics_comment: [null],
        });

        if (this.PID() !== '0') {
            this.getProject();
        }
    }

    ngOnDestroy(): void {
        this.teamsSubscription$?.unsubscribe();
    }

    getProject(): void {
        this.dataService.request('Project/get', {
            PID: this.PID()
        }).subscribe(response => {
            this.project = response.project;

            this.patchForm();
        });
    }

    patchForm(): void {

        this.form.patchValue({
            id: this.project.id,
            teams_created: this.project.teams_created == '1',
            teams_created_at: this.project.teams_created_at,
            teams_creator: this.project.teams_creator,
            teams_comment: this.project.teams_comment,

            cost_centre: this.project.cost_centre,
            cost_type: this.project.cost_type ?? '',

            dynamics_created: this.project.dynamics_created == '1',
            dynamics_created_at: this.project.dynamics_created_at,
            dynamics_creator: this.project.dynamics_creator,
            dynamics_comment: this.project.dynamics_comment,
        });

        this.teamsSubscription$ = this.form.get('teams_created').valueChanges.subscribe(val => {
            if (val) {
                this.formService.addValidators(
                    this.form, ['teams_comment',],
                    Validators.required
                );
            } else {
                this.formService.removeValidators(
                    this.form, ['teams_comment',],
                    Validators.required
                );
            }
        });
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
        if (this.viewMode == ViewMode.EDIT) {
            this.changeViewMode.emit(true);
        } else {
            this.changeViewMode.emit(false);
        }
    }

    update(): void {
        this.dataService.request('Project/updateExternal', {
            project: this.form.getRawValue(),
        }).subscribe(() => {
            this.toastrService.success('Erfolgreich gespeichert')
            this.setMode(ViewMode.VIEW);
            this.getProject();
            this.changeProject.emit();
        });
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }
}
